var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bizAuth.payTask.hasRight)?_c('div',{staticClass:"page-setting has-bc parent-frame task-payment",class:{'fixed': _vm.listIsFixed}},[_c('div',{staticClass:"tool-bar-mask"}),_vm._v(" "),_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_vm._v(" "),_c('task-payment-comp')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5520d698","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bussiness/mgtCategory/taskMgt/taskPayment.vue
// module id = null
// module chunks = 